import React from 'react'
import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import { dataStates } from '@garpix/fetcher'
import Button from '@/components/Button'
import Container from '@/components/Container'
import InstitutionsCard from '@/components/Cards/InstitutionsCard'
import Section from '@/components/Section'
import Title from '@/components/Title'
import InstitutionsFilters from './InstitutionsFilters'
import { levelValues } from '../const'
import { api } from '@/api'
import style from '../styles/best.module.scss'

const Institutions = (): React.ReactElement => {
  return (
    <Section>
      <FetcherList
        initFilter={{ page_size: 6, level: levelValues.secondary }}
        isScrollTop={false}
        isHistoryPush={false}
        api={api.getEducationList}
      >
        {({
          results,
          status,
          loadData,
          filterParams,
          showMore,
          isNext
        }: IFetcherListResults<any[]>) => {
          return (
            <Container>
              <Title type='h2' theme='h1' className={style.inst__title}>
                Учреждения
              </Title>

              <InstitutionsFilters
                handleFilter={loadData}
                initFilters={filterParams}
              />

              <div className={style.inst_results}>
                {results.map(el => {
                  return (
                    <InstitutionsCard
                      key={el.id}
                      id={el.id}
                      title={el.name}
                      city={el.property_region_value}
                      site={el.property_link_value}
                      logo={el.preview_picture}
                    />
                  )
                })}
              </div>
              {results.length === 0 && status === dataStates.loaded
                ? (
                  <p>К сожалению не удалось найти учебные учреждения</p>
                  )
                : null}

              {isNext
                ? (
                  <Button
                    disabled={status === dataStates.loading}
                    onClick={showMore}
                    size='large'
                    wide
                    outline
                    className={style.inst__more}
                  >
                    Показать еще
                  </Button>
                  )
                : null}
            </Container>
          )
        }}
      </FetcherList>
    </Section>
  )
}

export default Institutions
